export default {
	photos: [],
	address: null,
	promoCode: null
};
